import {
  SAVE_FIXER_DATA,
  ACTION_GET_COLOR_PROFILE_RELATION,
  ACTION_GET_DASTE_PROFILE_RELATION,
  ACTION_GET_TYPE_PROFILE_RELATION,
  GET_ALL_TYPE_AND_COLOR,
  SAVE_DASTE_PROFILE_LIST,
  SAVE_KASRI_BORESH_DATA,
  SAVE_LASTIK_DATA,
  SAVE_PRICE_PROFILE,
  SAVE_SELECT_COLOR,
  SAVE_TYPE_COLOR_LIST,
  SAVE_TYPES,
  SELECTED_TYPE_COLOR,
  SERI_PROFILE_TBL_DATA,
  SEARCHPROFILECATEGORY,
  SEARCHPROFILETYPECOLOR,
} from "Stores/actionTypes";
import ProfileService from "Services/http/endpoints/properties/ProfileService";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const getAllCountrybySid = (params) => {
  return async () => {
    try {
      const response = await ProfileService.getAllCountrybySid(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value.map((data) => {
          return {
            key: data.Id,
            title: data.Name,
            value: data.Id,
          };
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getAllSeriesByCountry = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getAllSeriesByCountry(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const updateValue = response.data.Value.map((data, index) => {
          return {
            ...data,
            key: data.Key,
            num: index,
            Keshvar: data.IdCountry,
            Type: data.Pop === "L" ? "lolayi" : "keshoyi",
            Struct: data.Struct === "U" ? "upvc" : "alu",
          };
        });
        dispatch({
          type: SERI_PROFILE_TBL_DATA,
          profileTblData: updateValue,
          profileTblDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const UpdatePriceProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.UpdatePriceProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("changePriceSuccess"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const UpdateWeightProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.UpdateWeightProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("changeWeightSuccess"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getAllDasteProfile = (params, index = -1) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getAllDasteProfile(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const dasteProfileList = response.data.Value;
        const update = dasteProfileList.map((m) => {
          return {
            ...m,
            key: m.Id,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_DASTE_PROFILE_LIST,
          dasteProfileList: update,
          selectedDasteProfile:
            index === -1
              ? update.length > 0
                ? update[0]
                : null
              : update[index],
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const setNameForSearchProfileCategory = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SEARCHPROFILECATEGORY,
      data,
    });
  };
};

export const getAllPriceProductProfile = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getAllPriceProductProfile(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const ListPartGroup = analyzePrice(response.data.Value.ListPartGroup);
        const ListPartUser = analyzePrice(response.data.Value.ListPartUser);
        const data = ListPartGroup.concat(ListPartUser);
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            key: index,
            num: (page - 1) * limit + index + 1,
          };
        });
        dispatch({
          type: SAVE_PRICE_PROFILE,
          priceProfileData: updatedData,
          priceProfileDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const UpdateSettingProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.UpdateSettingProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("settings_saved_successfully"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteDasteProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.deleteDasteProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("profile_category_deleted_successfully"),
          customClass: "success",
        });
        // setNameForSearchProfileCategory("");
        // const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        // dispatch(getAllDasteProfile(params));
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationDasteProfile(params));
        }
        return false;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getRelationDasteProfile = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getRelationDasteProfile(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_DASTE_PROFILE_RELATION,
          dataRelationDasteProfile: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const disableDasteProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.disableDasteProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        if (!data.Disable) {
          showNotify({
            text: translatorf("successfully_activated"),
            customClass: "success",
          });
        } else {
          showNotify({
            text: translatorf("successfully_disabled"),
            customClass: "success",
          });
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const InsertDasteProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.InsertDasteProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        if (response.data.StatusCode === 226) {
          showNotify({
            text: translatorf("profile_handle_updated_successfully"),
            customClass: "success",
          });
        } else {
          showNotify({
            text: translatorf("profile_category_successfully_added"),
            customClass: "success",
          });
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getAllTypeColor = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getAlltypeColor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((m, index) => {
          return {
            ...m,
            value: index,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_TYPE_COLOR_LIST,
          typeColorList: update,
        });
        dispatch({
          type: SELECTED_TYPE_COLOR,
          selectedTypeColor: update[0],
        });
        return { IdColor: data[0].IdColor, IdTypeColor: data[0].IdTypeColor };
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSelectTypeColor = (IdGroupProfile) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getAlltypeColor({
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdGroupProfile,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((m, index) => {
          return {
            ...m,
            value: m.IdTypeColor,
            label: m.Name,
          };
        });
        return update;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const setNameForSearchProfileTypeColor = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SEARCHPROFILETYPECOLOR,
      data,
    });
  };
};

export const UpdateTypeProfileName = (data) => {
  return async () => {
    try {
      const response = await ProfileService.UpdateTypeProfileName(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const InsertTypeProfile = (data) => {
  return async () => {
    try {
      const response = await ProfileService.InsertTypeProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getType = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getType(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_TYPES,
          types: update,
        });
        return data[0].Id;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSelectColor = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getSelectColor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_SELECT_COLOR,
          colors: update,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const editNameColor = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.editNameColor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("name_edited_successfully"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const AddColor = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.AddColor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("profile_color_added_successfully"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const AddTypeColor = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.AddTypeColor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("profile_type_added_successfully"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const InsertProductProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.InsertProductProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteColor = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.deleteColor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("profile_color_was_successfully_deleted"),
          customClass: "success",
        });
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllTypeAndColor(params));
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationColor(params));
        }
        return false;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getRelationColor = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getRelationColor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_COLOR_PROFILE_RELATION,
          dataRelationColor: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const disableColorProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.disableColorProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("profile_color_successfully_disabled"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteTypeProfile = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.deleteTypeProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("profile_type_deleted_successfully"),
          customClass: "success",
        });
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllTypeAndColor(params));
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationTypeProfile(params));
        }
        return false;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getRelationTypeProfile = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getRelationTypeProfile(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const typeRelation = response.data.Value.List;
        const update = typeRelation.map((m, index) => {
          return {
            ...m,
            index: index + 1,
          };
        });
        dispatch({
          type: ACTION_GET_TYPE_PROFILE_RELATION,
          dataRelationType: update,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const disableTypeProfile = (Id, idStruct, data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.disableTypeProfile(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch(getType(idStruct));
        showNotify({
          text: translatorf("profile_type_successfully_deactivated"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getFixer = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getFixer(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        dispatch({
          type: SAVE_FIXER_DATA,
          fixerData: data,
        });
        return data;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const UpdatePriceFixer = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.UpdatePriceFixer(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("changePriceSuccess"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getLastik = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getLastik(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        dispatch({
          type: SAVE_LASTIK_DATA,
          lastikData: data,
        });
        return data;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getKasriBoresh = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getKasriBoresh(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((m, index) => {
          return {
            ...m,
            num: index,
            IdGroupProfile: params.IdGroupProfile,
          };
        });
        dispatch({
          type: SAVE_KASRI_BORESH_DATA,
          kasriBoreshData: update,
        });
        return update;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const UpdateKasriBoresh = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.UpdateKasriBoresh(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("successfully_edited_crop_fraction"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const UpdatePriceLastic = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.UpdatePriceLastic(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("changePriceSuccess"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const updatePriceProductGlassGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.updatePriceProductGlassGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("group_price_change_successfully"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getAllTypeAndColor = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProfileService.getAllTypeAndColor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: GET_ALL_TYPE_AND_COLOR,
          allTypeColors: response.data.Value,
          allTypeColorsPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const disableColor = (row, data) => {
  return async (dispatch) => {
    try {
      // const msg = data.Disable ? "رنگ غیر فعال شد " : "  رنگ فعال شد";
      const response = await ProfileService.disableColor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        //todo
        //dispatch(getAllTypeAndColor());
        showNotify({
          text: translatorf(
            data.Disable ? "color_activated" : "color_disabled",
          ),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const disableTypeColor = (data) => {
  return async (dispatch) => {
    try {
      // const msg = data.Disable ? "نوع رنگ غیر فعال شد " : "  نوع رنگ فعال شد";
      const response = await ProfileService.disableTypeColor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        //todo
        //dispatch(getAllTypeAndColor());
        showNotify({
          text: translatorf(
            data.Disable ? "color_type_enabled" : "color_type_disabled",
          ),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};
